var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import omit from 'lodash/omit';
import React from 'react';
import EdsDropdown, { DropdownItem as EdsDropdownItem } from '@ellucian/react-design-system/core/es/Dropdown';
import Icon from '../Icon';
import Tokens from '../styles/Tokens';
import { createStyles, withStyles } from '../styles/withStyles';
const styles = createStyles({
    disabled: {},
    dropdownContainerLoader: {
        '& svg:not(.ds-spinner)': {
            display: 'none'
        },
        position: 'relative'
    },
    dropdownLoader: {
        position: 'absolute',
        right: Tokens.spacing40,
        top: '1.1875rem'
    },
    icon: {},
    select: {},
    smallDropdownLoader: {
        position: 'absolute',
        right: Tokens.spacing40,
        top: '0.5rem'
    }
});
const Dropdown = (props) => {
    const { classes, disabled, emptyOption, id, loading, multiple, native, options, size, value, onChange } = props, rest = __rest(props, ["classes", "disabled", "emptyOption", "id", "loading", "multiple", "native", "options", "size", "value", "onChange"]);
    const onChangeCallback = (event, child) => {
        if (onChange) {
            if (multiple) {
                const selectedOptions = [];
                if (options) {
                    event.target.value.forEach((checkedOptionValue) => {
                        const option = options.find(o => o.value === checkedOptionValue);
                        if (option) {
                            selectedOptions.push({
                                description: option.description,
                                value: option.value
                            });
                        }
                    });
                }
                onChange(selectedOptions, id, event);
            }
            else if (child) {
                const valueChanged = child.props.value === ' ' ? '' : child.props.value;
                let option;
                if (options) {
                    option = options.find(o => o.value === valueChanged);
                }
                if (!option) {
                    option = {
                        description: child.props.label,
                        value: valueChanged
                    };
                }
                onChange(option, id, event);
            }
        }
    };
    const classOverrides = omit(classes, [
        'dropdownContainerLoader',
        'dropdownLoader',
        'smallDropdownLoader'
    ]);
    let classOuterDiv;
    let classLoaderDiv;
    if (loading) {
        if (size === 'small') {
            classLoaderDiv = classes.smallDropdownLoader;
        }
        else {
            classLoaderDiv = classes.dropdownLoader;
        }
        classOuterDiv = classnames(classOuterDiv, classes.dropdownContainerLoader);
    }
    let allOptions = [];
    if (emptyOption) {
        allOptions.push(emptyOption);
    }
    if (options) {
        allOptions = allOptions.concat(options);
    }
    return (React.createElement("div", { className: classOuterDiv },
        React.createElement(EdsDropdown, Object.assign({ classes: classOverrides, disabled: loading || disabled, displayEmpty: true, id: id, multiple: multiple, native: native, size: size, value: value ? value : (multiple ? [] : ' '), onChange: onChangeCallback }, rest), allOptions.map((option, iOption) => (native ? (React.createElement("option", { key: `${id}_${iOption}`, value: option.value || ' ' }, option.description)) : (React.createElement(EdsDropdownItem, { key: `${id}_${iOption}`, label: option.description, LeftIconComponent: option.leftIcon, RightIconComponent: option.rightIcon, value: option.value || ' ' }))))),
        loading && (React.createElement("span", { className: classLoaderDiv },
            React.createElement(Icon, { large: true, marginRight: true, name: "spinner", spin: true })))));
};
Dropdown.defaultProps = {
    fullWidth: true,
    id: '',
    label: ''
};
const DropdownWithStyles = withStyles(styles)(Dropdown);
export default DropdownWithStyles;
